<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="Contact Us" src="/images/sub/sub-visual.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <!-- S: 내용 -->
        <page-section class="page-section--first pb-0">
            <v-row justify="space-between">
                <template v-for="(item, index) in ko">
                    <v-col v-if="index !== 0" :key="index" cols="auto" class="d-none d-lg-flex align-self-strech ml-n1px">
                        <v-divider vertical class="h-100 border-dark" />
                    </v-col>
                    <v-col :key="index" data-aos="fade-up" :data-aos-delay="100 * (index + 1)" cols="12" sm="6" md="4" lg="">
                        <div class="text-center">
                            <v-img max-width="36" :src="item.icon" class="mx-auto mb-10px" alt="" />
                            <div class="tit tit--xs line-height-1">
                                {{ item.name }}
                            </div>
                            <div class="pt-16px pt-md-20px">
                                <template v-if="item.address">
                                    <p class="txt" v-html="item.address" />
                                </template>
                                <template v-if="item.tel">
                                    <a :href="`tel:${item.tel}`" class="txt grey--text text-decoration-underline">
                                        {{ item.tel }}
                                    </a>
                                </template>
                                <template v-if="item.email">
                                    <a :href="`mailto:${item.email}`" class="txt grey--text text-decoration-underline">
                                        {{ item.email }}
                                    </a>
                                </template>
                                <template v-if="item.apps">
                                    <v-row align="center" justify="center" class="row--sm">
                                        <v-col v-for="(app, index) in item.apps" :key="index" cols="auto">
                                            <a :href="app.link" target="_blank">
                                                <v-img width="30" :aspect-ratio="1 / 1" :src="app.icon" :alt="item.name" />
                                            </a>
                                        </v-col>
                                    </v-row>
                                </template>
                            </div>
                        </div>
                    </v-col>
                </template>
            </v-row>
        </page-section>
        <!-- E: 내용 -->

        <!-- S: 지도이미지 -->
        <page-section class="page-section--sm">
            <v-img data-aos="fade" src="/images/sub/contact/map.png" alt="" />
        </page-section>
        <!-- E: 지도이미지 -->

        <!-- S: Inquiries -->
        <page-section class="page-section--last pt-0">
            <div class="pb-16px pb-md-20px">
                <v-row align="end" class="row--sm">
                    <v-col>
                        <h4 class="tit tit--xs">상담 신청</h4>
                    </v-col>
                    <v-col cols="auto">
                        <div class="txt txt--xs text-right"><span class="red--text">* </span>기입필수</div>
                    </v-col>
                </v-row>
            </div>
            <form-input skin="inquiries"></form-input>
        </page-section>
        <!-- E: Inquiries -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";

import FormInput from "@/components/client/ko/form/form-input.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,

        FormInput,
    },
    props: {},
    data() {
        return {
            ko: [
                {
                    name: "Address",
                    icon: "/images/icon/icon-address.png",
                    address: "서울 강남구 봉은사로 325, <br>라임타워 13층 (06103)",
                },
                {
                    name: "Tel",
                    icon: "/images/icon/icon-tel.png",
                    tel: "02-723-6510",
                },
                {
                    name: "E-mail",
                    icon: "/images/icon/icon-email.png",
                    email: "support@sagelaw.co.kr",
                },
                {
                    name: "APP",
                    icon: "/images/icon/icon-app.png",
                    apps: [
                        {
                            name: "Kakao Map",
                            icon: "/images/icon/icon-kakaomap.png",
                            link: "https://place.map.kakao.com/25014747",
                        },
                        {
                            name: "Naver Map",
                            icon: "/images/icon/icon-navermap.png",
                            link: "https://naver.me/FUhLaFJZ",
                        },
                        {
                            name: "TMAP",
                            icon: "/images/icon/icon-tmap.png",
                            link: "https://tmap.life/599b1ec8",
                        },
                        {
                            name: "Google Maps",
                            icon: "/images/icon/icon-googlemap.png",
                            link: "https://maps.app.goo.gl/DK4ATENnewzrKxyn6",
                        },
                    ],
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
